module.exports = __webpack_public_path__ + "static/media/mcardle.be6abd5e.png";